import React from 'react';
import c from 'classnames';

import { SearchForumFollowTopic } from '../../../../components';

export interface ForumSearchFollowedTopicsProps {
  uid?: number;
  className?: string;
}

const ForumSearchFollowedTopics: React.FC<ForumSearchFollowedTopicsProps> = (props) => {
  const { uid, className } = props;

  const classNames = c('ViewForumSearchFollowedTopics', className);

  return (
    <div className={classNames}>
      <SearchForumFollowTopic uid={uid}>
        <SearchForumFollowTopic.Results />
        <SearchForumFollowTopic.Pagination />
      </SearchForumFollowTopic>
    </div>
  );
};

export default ForumSearchFollowedTopics;
